'use client'

import { CardImageLong, CardImageLongBlock as Block } from '@shc/ui'
import slugify from 'slugify'
import Analytics from '@components/analytics'
import NextImage from '@components/next-image'
import getImageSizes from '@helpers/getImageSizes'
import type { TypeCardImageLongBlockFields, TypeCardImageLongItemFields } from '@lib/generated-types'
import { routeMapper } from '@lib/menu-item-mapper'
import { containerSizeMap, pyMap } from '@lib/token-maps'

const CardImageLongBlock = ({
  sectionLink,
  blockAlignment,
  cards,
  paddingTop,
  paddingBottom,
  width,
}: TypeCardImageLongBlockFields) => (
  <Block
    id={typeof sectionLink === 'undefined' ? undefined : slugify(sectionLink)}
    containerAlignment={blockAlignment}
    containerSize={containerSizeMap[width]}
    paddingBottom={pyMap[paddingBottom]}
    paddingTop={pyMap[paddingTop]}>
    {cards.map(({ fields, sys }) => {
      const fieldsData = fields as TypeCardImageLongItemFields
      const { route, isInternal } = routeMapper(fieldsData.link, fieldsData.anchorOrExternalLink)
      const image = fieldsData.image.fields?.image.fields
      const imageDimensions = image?.file.details.image
      const title = fieldsData.title

      return (
        <Analytics
          key={sys.id}
          click={{
            name: 'component_click',
            data: {},
          }}
          contexts={[
            {
              name: 'component',
              data: {
                component_text: title,
                component_url: route || title,
              },
            },
            {
              name: 'content',
              data: {
                content_type: sys.contentType.sys.id,
                content_entry_id: sys.id,
                content_level: 'item',
                content_internal_name: title,
              },
            },
          ]}>
          <CardImageLong
            description={fieldsData.summary}
            heading={title}
            href={!!route ? route : undefined}
            noAction={!route}
            preHeading={fieldsData.preHeading}
            slots={{
              image: NextImage
            }}
            slotProps={{
              image: {
                alt: image?.title,
                height: imageDimensions?.height,
                sizes: getImageSizes('100vw', '100vw', '286px', '286px', '286px', '286px'),
                src: image?.file.url,
                width: imageDimensions?.width,
              }
            }}
            target={isInternal ? undefined : '_blank'}
          />
        </Analytics>
      )
    })}
  </Block>
)

export default CardImageLongBlock
